import { render, staticRenderFns } from "./GenerationOptionsMenu.vue?vue&type=template&id=124b44a0&scoped=true&"
import script from "./GenerationOptionsMenu.vue?vue&type=script&lang=js&"
export * from "./GenerationOptionsMenu.vue?vue&type=script&lang=js&"
import style0 from "./GenerationOptionsMenu.vue?vue&type=style&index=0&id=124b44a0&lang=scss&scoped=true&"
import style1 from "./GenerationOptionsMenu.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124b44a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
